import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, Validators } from '@angular/forms';
import { createMask, InputMaskModule } from '@ngneat/input-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { parsePhoneNumberWithError, validatePhoneNumberLength } from 'libphonenumber-js';

@Component({
  selector: 'adm-phone-number-input',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, InputMaskModule],
  templateUrl: './phone-number-input.component.html',
  styleUrl: './phone-number-input.component.scss',
})
export class PhoneNumberInputComponent implements OnInit {
  @Input()
  formItem: FormControl<string>;
  @Input()
  placeholder: string = 'Brugerens telefonnummer';
  @Input()
  label: string = 'tlf.';
  @Input()
  hintText: string | null = null;
  @Input()
  countryCode: FormControl<number>;

  ngOnInit(): void {
    this.formItem.addValidators([Validators.required, this.validatePhoneNumber.bind(this)]);
  }

  numberInputMask = createMask({
    rightAlign: false,
    regex: '^\\d+$',
    // alias: 'numeric',
    placeholder: '',
    // min: 0
  });

  validatePhoneNumber(control: AbstractControl): ValidationErrors | null {
    const inputPhoneNumber = control.value;
    if (!inputPhoneNumber) return null;

    try {
      const parsedPhoneNumber = parsePhoneNumberWithError(inputPhoneNumber, {
        defaultCallingCode: this.countryCode?.value?.toString(),
        extract: false,
      });

      switch (validatePhoneNumberLength(inputPhoneNumber, { defaultCallingCode: this.countryCode?.value?.toString() })) {
        case 'TOO_SHORT':
          return { invalidPhoneNumber: 'Telefonnummeret er for kort.' };
        case 'TOO_LONG':
          return { invalidPhoneNumber: 'Telefonnummeret er for langt.' };
      }

      if (!parsedPhoneNumber?.isValid()) {
        return { invalidPhoneNumber: 'Det indtastede telefonnr. er ikke gyldigt.' };
      }
    } catch (e: any) {
      switch (e.message) {
        case 'NOT_A_NUMBER':
          return { invalidPhoneNumber: 'Telefonnummeret indeholder ugyldige tegn.' };
        case 'INVALID_COUNTRY':
          return { invalidPhoneNumber: 'Ugyldigt landekode.' };
        case 'TOO_SHORT':
          return { invalidPhoneNumber: 'Telefonnummeret er for kort.' };
        case 'TOO_LONG':
          return { invalidPhoneNumber: 'Telefonnummeret er for langt.' };
        default:
          return { invalidPhoneNumber: 'Det indtastede telefonnr. er ikke gyldigt.' };
      }
    }

    return null;
  }
}
